module.exports = __webpack_public_path__ + "img/plakplintlaminaat.024c082a.jpg";